import { Event } from './Event';
import { locationExample } from './Location.example';

export const eventListExample = Event.array().parse([
  {
    id: 'event:1',
    locationId: locationExample.locationId,
    name: 'Example Event 1',
    description: 'This is an example event.',
    eyeCatchURL: 'https://picsum.photos/seed/event1/200',
    date: '2021-01-02T12:00:00.000+09:00',
    startTime: '12:00',
    endTime: '17:00',
    createdAt: '2021-01-01T00:00:00.000Z',
    updatedAt: '2021-01-01T00:00:00.000Z',
    capacity: 10,
    attendees: 5,
  },
  {
    id: 'event:2',
    locationId: locationExample.locationId,
    name: 'Example Event 2',
    description: 'This is an example event.',
    eyeCatchURL: 'https://picsum.photos/seed/event2/200',
    bannerURL: 'https://picsum.photos/seed/event2/400/200',
    date: '2021-01-03T18:00:00.000+09:00',
    startTime: '18:00',
    endTime: '20:00',
    createdAt: '2021-01-02T00:00:00.000Z',
    updatedAt: '2021-01-02T00:00:00.000Z',
    capacity: 5,
    attendees: 2,
  },
  {
    id: 'event:3',
    locationId: locationExample.locationId,
    name: 'Example Event 3',
    description: 'This is an example event.',
    eyeCatchURL: 'https://picsum.photos/seed/event3/200',
    bannerURL: 'https://picsum.photos/seed/event3/400/200',
    date: '2021-01-04T10:00:00.000+09:00',
    startTime: '10:00',
    endTime: '12:00',
    createdAt: '2021-01-03T00:00:00.000Z',
    updatedAt: '2021-01-03T00:00:00.000Z',
    capacity: 15,
    attendees: 12,
  },
]);
